<template>
    <div class="user-table-container">
        <div class="HeaderTop">
            <div class="SearchHead">
                <el-select size="medium" v-model="TypeVal" @change="ReSetPage" clearable>
                    <el-option v-for="item in QueryList.sq_status" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
                <el-input size="medium" placeholder="搜索" v-model="SearchVal" @keyup.enter.native="ReSetPage">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="ReSetPage"></i>
                </el-input>
            </div>
            <div class="BtnHead">
                <el-button v-throttle class="BgColor" size="small" type="primary" @click="ToggleDig('Add')">申请</el-button>
               <!-- <el-button v-throttle size="small" type="primary" @click="SeleUser('File')">导入</el-button>
                <el-button v-throttle size="small" type="primary" @click="SeleUser('DownMol')">下载模板</el-button> -->
                <!-- <el-dropdown trigger="click" @command="SeleUser">
                    <el-button v-throttle size="small" type="primary">更多</el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="DownMol">下载模板</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
            </div>
        </div>
        <el-table :data="Data" border stripe style="width: 100%;" class="custom-header-table" v-loading="loading">
            <el-table-column prop="record_number" label="编号" min-width="50"></el-table-column>
            <el-table-column prop="record_name" label="标题" min-width="120"></el-table-column>
            <el-table-column prop="user_name" label="申请人" min-width="70"></el-table-column>
            <el-table-column prop="sq_status_name" label="状态" min-width="70">
                <template slot-scope="scope">
                    <el-tag size="small" v-if="scope.row.status==1" :type="scope.row.status?'danger':''">{{scope.row.status?'待修改':scope.row.sq_status_name}}</el-tag>
                    <el-tag size="small" v-else>{{scope.row.sq_status_name}}</el-tag>
                    <!-- <i v-if="scope.row.status==1" class="NavIcon el-icon-view" @click="OpenMsg(scope.row.reject_reason)"></i>
                    <i v-if="scope.row.sq_status==11" class="NavIcon el-icon-view" @click="OpenMsg(scope.row.yuanyi)"></i> -->
                    <el-link type="primary" v-if="scope.row.status==1" :underline="false" @click="OpenMsg(scope.row.reject_reason)">驳回原因</el-link>
                    <el-link type="primary" v-if="scope.row.status==11" :underline="false" @click="OpenMsg(scope.row.yuanyi)">驳回原因</el-link>
                </template>
            </el-table-column>
            <el-table-column prop="update_time" label="提交时间" min-width="100"></el-table-column>
            <el-table-column label="操作" min-width="150" align="center">
                <template slot-scope="scope">
                    <!-- <el-tooltip effect="dark" content="查看" placement="top-start">                        
                        <i class="NavIcon el-icon-view" @click="LockDig(scope.row)"></i>                    
                    </el-tooltip> 
                    <el-tooltip effect="dark" content="编辑" placement="top-start">
                        <i v-if="scope.row.sq_status ==0 || scope.row.status==1" class="NavIcon el-icon-edit" @click="ToggleDig(scope.row)"></i>
                    </el-tooltip> 
                    <el-tooltip effect="dark" content="删除" placement="top-start">
                        <i v-if="scope.row.sq_status ==0 || scope.row.status==1" class="NavIcon el-icon-delete" @click="Delete(scope.row.id)"></i>
                    </el-tooltip> -->
                    <el-button v-if="scope.row.sq_status ==0 || scope.row.status==1" v-throttle type="primary" size="mini" @click="ToggleDig(scope.row)">编辑</el-button>
                    <el-button v-if="scope.row.sq_status ==0 || scope.row.status==1" v-throttle type="danger" size="mini" @click="Delete(scope.row.id)">删除</el-button>
                    <el-button v-throttle type="primary" size="mini" @click="LockDig(scope.row)">查看申请内容</el-button>
                    <el-button v-if="scope.row.is_user_yj" v-throttle type="primary" size="mini" @click="LockPS(scope.row)">查看评审意见</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination background @size-change="SizeChange" @current-change="PageChange" :current-page="Page" 
            layout="total,prev,pager,next,sizes"
            :total="Totol">
        </el-pagination>
        <FieldMol
              :visible="NewData.NewBlon"
              :Type="Type"
              :rowData="RowData"
              :newData="NewData"
              :rowtype="RowType"
              :sysType="SysType"
              @cancel="$Tools.ResetData(NewData)"
              @submit="SucData"
            />
        <PingShenUser :visible="PSBlon" :rowData="PSData" @cancel="PSBlon = false" />
        <el-dialog :title="DownData.Type=='Down'?'下载模板':'导入'" :visible.sync="DownData.Blon" width="40%" class="BorderRadius" :close-on-press-escape="false" :close-on-click-modal="false">
            <div class="DigItem">
                <div class="DigItemTit">类型：</div>
                <el-select class="Wid120" size="medium" v-model="DownData.Id" clearable placeholder="类型">
                    <el-option v-for="i in RowType" :key="i.id" :label="i.group_name" :value="i.id"></el-option>
                </el-select>
            </div>
            <div slot="footer">
                <div class="footer">
                    <el-button v-throttle size="small" @click="$Tools.ResetData(DownData)">取消</el-button>
                    <el-button v-if="DownData.Type =='Down'" v-throttle class="BgColor" size="small" type="primary" @click="DownSuc">确定</el-button>
                    <el-upload class="MarLt" v-else action="none" :show-file-list="false" :http-request="UploadFlie">
                        <el-button v-throttle size="small" type="primary">确定</el-button>
                    </el-upload>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "",
        data() {
            return {
                loading:false,
                SearchVal:"",
                TypeVal:"",
                QueryList:"",
                Data: [],
                Page:1,
                PageSize:10,
                Totol:0,
                Type:'Add',
                NewData:{
                    id:'',
                    NewBlon:false,
                    record_name:"",
                },
                RowType:[],
                RowData:{
                    group: [], // 表单字段组，提前声明数组
                    gl_file: [] // 附件列表，提前声明数组
                },
                DownData:{
                    Blon:false,
                    Type:"Down",
                    Id:"",
                },
                PSData:{},//评审数据
                PSBlon:false,
                SysData:"",
                SysType:"",
            };
        },
        mounted(quy) {
            if(this.$route.query.type){
                this.TypeVal = this.$route.query.type;
            }
            this.SysData = JSON.parse(sessionStorage.getItem("SYSTEM-Data"));
            this.SysType = this.SysData.id.toString();
            this.GetData();
            this.GetQuery();
        },
        methods: {
            GetData(){
                this.loading = true;
                this.$get('/api/record/list',{
                    keyword:this.SearchVal,
                    page:this.Page,
                    page_size:this.PageSize,
                    sq_status:this.TypeVal,
                    system_sub_id:this.SysType,
                }).then(res=>{
                    this.loading = false;
                    if(res){
                        this.Data = res.data.list;
                        this.Totol = res.data.total;
                    }
                })
            },
            GetQuery(){
                this.$get('/api/auth/system').then(res=>{
                    if(res){
                        this.QueryList = res.data;
                    }
                })
            },
            GetTypeList(){
                this.$get('/api/record/allData',{
                    system_sub_id:this.SysType,
                }).then(res=>{
                    if(res){
                        this.RowType = res.data.list;
                    }
                })
            },
            GetDetail(id){
                this.$get('/api/record/detail',{
                    id:id,
                }).then(res=>{
                    if(res){
                        var Data = JSON.parse(JSON.stringify(res.data));
                        Data.group = Data.group.map(item=>{
                            if (item.field_options && typeof item.field_options === 'string') {
                                try {
                                    item.field_options = JSON.parse(item.field_options);
                                    if(item.field_type == 'checkbox'){item.default_value = item.default_value?item.default_value.split(","):[];}
                                } catch (e) {
                                    item.field_options = [];
                                }
                            }
                            return item;
                        })
                        Data.gl_file = Data.gl_file?Data.gl_file.split(","):[];
                        this.RowData = Data;
                    }
                })
            },
            LockPS(row){
                this.$get('/api/record/shenhe',{
                    id:row.id,
                }).then(res=>{
                    if(res){
                        this.PSBlon = true;
                        this.PSData = res.data;
                    }
                })
            },
            LockDig(row){
                this.Type= "Lock";
                this.NewData.record_name = row.record_name;
                this.GetDetail(row.id)
                this.NewData.NewBlon = true;
            },
            ToggleDig(row){
                this.$Tools.ResetData(this.NewData)
                if(row!='Add'){
                    this.Type="Edi";
                    this.NewData.id = row.id;
                    this.NewData.record_name = row.record_name;
                    this.GetDetail(row.id)
                }else{
                    this.GetTypeList();
                    this.RowData={
                        group: [],
                        gl_file: [],
                    };
                    this.Type='Add';
                }
                this.NewData.NewBlon = true;
            },
            SucData(q,n){
                this.$confirm("确定是否"+(n?'提交':'保存')+"?", "提示", {
                    type: "warning"
                }).then(() => {
                   var url = '/api/record/add';
                   if(this.Type!='Add'){
                       url = '/api/record/edit';
                   }
                   this.$post(url,q).then(res=>{
                       if(res){
                           this.$message.success(res.msg);
                           this.GetData();
                           this.$Tools.ResetData(this.NewData)
                       }
                   })
                })
            },
            Delete(id) {
                this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
                    type: "warning"
                }).then(() => {
                    this.$del('/api/record/delete/',{
                        id:id,
                    }).then(res=>{
                        if(res){
                            this.$message.success("删除成功!");
                            this.GetData();
                        }
                    })
                })
            },
            SeleUser(type){
                this.GetTypeList();
                if(type == "DownMol"){
                    this.DownData.Type = "Down";
                };
                if(type == "File"){
                    this.DownData.Type = "File";
                };
                this.DownData.Blon = true;
                this.DownData.Id = ""; 
            },
            DownSuc(){
                if(this.DownData.Type == "Down"){
                    this.DownMol();
                }
                this.$Tools.ResetData(this.DownData)
            },
            DownMol(){
               this.$get('/api/record/moban',{
                   SystemCode:this.ApiType,
                   group_id:this.DownData.Id,
                   system_sub_id:this.SysType,
               }).then(res=>{
                   if(res){
                       this.$message.success(res.msg);
                       window.open(res.data.download_url)
                   }
               })
            },
            UploadFlie(res){
                var file = res.file;
                if (this.$Tools.ChangeExcel(file)) {
                    this.$message.error('只能上传Excel文件格式 (.xls, .xlsx, .xlsm, .xlsb)');
                    return false;
                }
                const loading = this.$loading({lock: true,text: 'Loading',spinner: 'el-icon-loading',background: 'rgba(0, 0, 0, 0.7)'});
                try {
                    var fd = new FormData()
                    fd.append('file',file);
                    fd.append('SystemCode',this.ApiType);
                    fd.append('group_id',this.DownData.Id);
                    fd.append('system_sub_id',this.SysType);
                    this.$post("/api/record/daoru",fd,{
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        }
                    }).then((res)=>{
                        loading.close();
                        this.$message.success(res.msg);
                        this.GetData();
                    }).catch((res)=>{
                        loading.close();
                    })
                } catch (error) {
                    loading.close();
                }
                this.$Tools.ResetData(this.DownData)
            },
            OpenMsg(msg){
                this.$alert(msg, '提示', {
                    confirmButtonText: '确定',
                    callback: action => {}
                });
            },
            SizeChange(val){
                this.PageSize = val;
                this.GetData();
            },
            PageChange(val){
                this.Page = val;
                this.GetData();
            },
            ReSetPage(){
                this.Page = 1;
                this.GetData();
            },
        }
    };
</script>

<style scoped>
    .MarLt{
        margin-left: 10px;
    }
    .BtnHead{
        gap:0;
    }
    .footer{
        display: flex;
        align-items: center;
        justify-content: flex-end;
    }
</style>
